import Colors from '../utils/colors';

const PlusLabelCircledIcon = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill={Colors.tertiary} />
    <path
      d="M30.1508 24.8872C30.1508 27.0232 28.4192 28.7548 26.2832 28.7548C24.1471 28.7548 22.4155 27.0232 22.4155 24.8872C22.4155 22.7511 24.1471 21.0195 26.2832 21.0195C28.4192 21.0195 30.1508 22.7511 30.1508 24.8872Z"
      stroke={Colors.dark}
      strokeWidth="1.5"
    />
    <path
      d="M23.9942 14.728C23.9942 16.864 22.2626 18.5956 20.1266 18.5956C17.9905 18.5956 16.2589 16.864 16.2589 14.728C16.2589 12.592 17.9905 10.8604 20.1266 10.8604C22.2626 10.8604 23.9942 12.592 23.9942 14.728Z"
      stroke={Colors.dark}
      strokeWidth="1.5"
    />
    <path
      d="M17.837 24.8862C17.837 27.0222 16.1054 28.7538 13.9693 28.7538C11.8333 28.7538 10.1017 27.0222 10.1017 24.8862C10.1017 22.7502 11.8333 21.0186 13.9693 21.0186C16.1054 21.0186 17.837 22.7502 17.837 24.8862Z"
      stroke={Colors.dark}
      strokeWidth="1.5"
    />
  </svg>
);

export default PlusLabelCircledIcon;
